<template>
  <!-- banner-page -->
  <BannerPageComponent />
  <!-- /banner-page -->

  <!-- wg-map -->
  <MapComponent />
  <!-- /wg-map -->

  <!-- wg-quetion -->
  <QuestionComponent />
  <!-- /wg-quetion -->
</template>

<script>
import BannerPageComponent from './BannerPageComponent.vue';
import MapComponent from './MapComponent.vue';
import QuestionComponent from './QuestionComponent.vue';

export default {
  name: "ContactComponent",
  components: {
    BannerPageComponent,
    MapComponent,
    QuestionComponent
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
